import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'

import logo from 'assets/logo.svg'
import { Link, useLocation } from 'react-router-dom'

import useOutsideCloseClicked from 'utils/useOutsideClosedClicked'
import AboutUs from './navigation/sub-menu/WhyManuva'
import Retail from './navigation/sub-menu/PlatformService'
import MobileNav from './MobileNav'

const Header = ({ refTabOurSolution }) => {
  const [dropdownOpen, setDropdownOpen] = useState('')
  const [subDropdownOpen, setSubDropdownOpen] = useState('')

  const [isOpenMobileMenu, setIsMobileMenu] = useState(false)

  const toogleRef = useRef(null)
  const wrapperRef = useRef(null)
  useOutsideCloseClicked(
    setDropdownOpen,
    setSubDropdownOpen,
    toogleRef,
    wrapperRef
  )

  const location = useLocation()
  const isOrangeTheme = location.pathname === '/retail'

  return (
    <header className="bg-[#F7F8FA]">
      <MobileNav
        isOpenMobileMenu={isOpenMobileMenu}
        setIsOpenMobileMenu={setIsMobileMenu}
      />

      <div className="flex items-center justify-between gap-x-10 xl:gap-x-[53px] h-14 md:h-16 lg:h-24 max-w-[1328px] mx-6 lg:mx-14 left-0 right-0 xl:pr-16 xl:m-auto">
        <Link to="/">
          <img className="w-[114px] lg:w-[153px]" src={logo} alt="logo" />
        </Link>

        <div className="hidden lg:flex items-center justify-between w-full">
          <nav ref={wrapperRef} className="flex gap-x-8">
            <AboutUs
              ArrowIcon={ArrowIcon}
              dropdownOpen={dropdownOpen}
              setDropdownOpen={setDropdownOpen}
            />
            <Retail
              refTabOurSolution={refTabOurSolution}
              ArrowIcon={ArrowIcon}
              dropdownOpen={dropdownOpen}
              setDropdownOpen={setDropdownOpen}
              subDropdownOpen={subDropdownOpen}
              setSubDropdownOpen={setSubDropdownOpen}
            />

            <Link
              className="text-[#101838] text-sm xl:text-base leading-[150%]"
              to="/"
              onClick={() => {
                setTimeout(() => {
                  document.getElementById('customer').scrollIntoView()
                }, 500)
              }}

            >
              Our Customers
            </Link>

          </nav>

          <div className="flex gap-x-4 h-[48px]">
            <div className="relative hidden xl:flex border rounded-[40px] border-[#EAEBEF] w-[157px] py-[12px] bg-white">
              <SearchIcon className="absolute ml-[14px] m-auto top-0 bottom-0" />
              <input
                placeholder="Search..."
                type="text"
                className="text-sm font-normal ml-[42px] w-[100px]"
              />
            </div>

            <div className="flex gap-x-2">
              <a
                href="https://seller.manuva.com/login"
                target="_blank"
                className={`flex items-center justify-center w-[114px] font-medium ${
                  isOrangeTheme ? 'text-[#F4633A]' : 'text-[#003DA6]'
                }`}
                rel="noreferrer"
              >
                Sign Up
              </a>
              <button
                className={`w-[114px] ${
                  isOrangeTheme ? 'bg-[#F4633A]' : 'bg-[#003DA6]'
                } rounded-[100px] text-white font-medium`}
              >
                <a
                  href="https://seller.manuva.com/login"
                  target="_blank"
                  rel="noreferrer"
                >
                  Sign In
                </a>
              </button>
            </div>
          </div>
        </div>

        <HamburgerButton
          className="block lg:hidden"
          onClick={() => setIsMobileMenu(true)}
        />
      </div>
    </header>
  )
}

const SearchIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.16669 17.1667C13.3088 17.1667 16.6667 13.8088 16.6667 9.66667C16.6667 5.52454 13.3088 2.16667 9.16669 2.16667C5.02455 2.16667 1.66669 5.52454 1.66669 9.66667C1.66669 13.8088 5.02455 17.1667 9.16669 17.1667Z"
        stroke="#9AA3B2"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3333 18.8333L15 15.5"
        stroke="#9AA3B2"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const ArrowIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.2801 5.9668L8.93343 10.3135C8.42009 10.8268 7.58009 10.8268 7.06676 10.3135L2.72009 5.9668"
        stroke="#292D32"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const HamburgerButton = ({ className, onClick }) => {
  return (
    <button className={className} onClick={onClick}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 6H20M4 12H20M4 18H20"
          stroke="#152C5B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  )
}

Header.propTypes = {
  refTabOurSolution: PropTypes.node
}

HamburgerButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
}

SearchIcon.propTypes = {
  className: PropTypes.string
}

ArrowIcon.propTypes = {
  className: PropTypes.string
}

export default Header
